import Service 			from "./../../Libs/Service";

let Layout = new Service({

	Name: "Layout",

	Events: {
		"Current User Loaded": function() {

			if (User.currentUser) {
				this.page = window.localStorage.getItem(`layout-page:${User.currentUser.id}`) || 'campaigns';

				Broadcast.call("Current Page Changed", [this.page]);
			}

		},

	},

	Actions: {

	},

	init() {

		this.page = 'campaigns';

	},

	changePage(page) {

		this.page = page;
		if (User.currentUser) {
			window.localStorage.setItem(`layout-page:${User.currentUser.id}`, page);
			Broadcast.call("Current Page Changed", [this.page]);
		}

	}


});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Layout) Layout = window.Layout;
else window.Layout = Layout;

export { Layout }

